var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.0001C13.2624 12.0001 14.2857 10.9768 14.2857 9.71443C14.2857 8.45206 13.2624 7.42871 12 7.42871C10.7376 7.42871 9.71429 8.45206 9.71429 9.71443C9.71429 10.9768 10.7376 12.0001 12 12.0001Z",
    stroke: "#6B6A69",
    strokeWidth: 0.571429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.42857H5.14286V6.28571C5.14286 5.67951 5.38367 5.09812 5.81233 4.66947C6.24098 4.24082 6.82236 4 7.42857 4H16.5714C17.1776 4 17.759 4.24082 18.1877 4.66947C18.6163 5.09812 18.8571 5.67951 18.8571 6.28571V17.7143C18.8571 18.3205 18.6163 18.9019 18.1877 19.3305C17.759 19.7592 17.1776 20 16.5714 20H7.42857C6.82236 20 6.24098 19.7592 5.81233 19.3305C5.38367 18.9019 5.14286 18.3205 5.14286 17.7143V16.5714H4M4 12H5.14286M4 9.71429H5.14286M4 14.2857H5.14286",
    stroke: "#6B6A69",
    strokeWidth: 0.571429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4286 15.4286V14.2857C15.4286 13.6795 15.1878 13.0981 14.7591 12.6695C14.3305 12.2408 13.7491 12 13.1429 12H10.8572C10.2509 12 9.66957 12.2408 9.24091 12.6695C8.81226 13.0981 8.57144 13.6795 8.57144 14.2857V15.4286C8.57144 15.7317 8.69185 16.0224 8.90618 16.2367C9.1205 16.451 9.41119 16.5714 9.7143 16.5714H14.2857C14.5888 16.5714 14.8795 16.451 15.0938 16.2367C15.3082 16.0224 15.4286 15.7317 15.4286 15.4286Z",
    stroke: "#6B6A69",
    strokeWidth: 0.571429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContacts);
export default __webpack_public_path__ + "static/media/icon-contacts.514c50687d735e8dfa97a27b9b1d508b.svg";
export { ForwardRef as ReactComponent };